export const MonthConstants = {
  MT: {
    MONTH_ROOT_ID: 9900
  },
  MC: {
    MONTHS_ARRAY_IDS: [9900, 9901, 9902, 9903, 9904, 9905, 9906, 9907, 9908, 9909, 9910, 9911]
  }
};
